module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAAICAYAAACyNQwAAAAAgElEQVQ4jd2U2wqAMAxDs4l4efT/v9MLMpXCIqVMJojgPBBKxvaQtdThHnKvivKqUk6JXuON36O039Q5PRVUDeZtklSw2oiBvgQDrkYnDNYA6GO1v1sK0tEFwChVgg0A2kLDXDGX2p0sHEXpWPeTUZykY79fHjmerHuea95d9wAOMGUzHAvnizQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/shadow.png
// module id = HDFt
// module chunks = 9